const API_BASE =
  process.env.REACT_APP_API_BASE ||
  "https://damp-thicket-07899-72417fa8b047.herokuapp.com";

// Content the owner edits in the admin app.
//
// Every consumer passes its own built-in data as a fallback, and gets that back
// unchanged if the section is empty or this service is unreachable. The site
// must look exactly as it does today when the API is down — a blank homepage is
// far worse than a slightly stale one.
export async function fetchSiteContent() {
  try {
    const resp = await fetch(`${API_BASE}/public/site-content`);
    if (!resp.ok) return null;
    return await resp.json();
  } catch {
    return null;
  }
}

export const sectionOr = (content, section, fallback) => {
  const items = content && content[section];
  return Array.isArray(items) && items.length > 0 ? items : fallback;
};
